import { formatNumber } from '@blockworks/platform/utils';

import { cn } from '../../style-system';

type CompactNumberProps = {
    number?: number;
    className?: string;
    fractionDigits?: number;
    suffix?: string;
};

const CompactNumber = ({ number, fractionDigits, className, suffix }: CompactNumberProps) => {
    if (!number) {
        return null;
    }

    return (
        <span className={cn(className)}>
            {formatNumber(number, fractionDigits)}
            {suffix}
        </span>
    );
};

export type { CompactNumberProps };
export { CompactNumber };
